import { Fragment } from 'react'

import { FormattedMessage } from 'react-intl'

import Theme from '@theme'
import { Container, H5, Icon } from '@tribegroup'
import Price from '../Price/Price'
import { PricePanelAmountStyled, PricePanelAmountWrapper } from './PricePanel.styled'

interface IProps {
  price: number
  currency: string
  taxDisplayName?: string
  greyedOut?: boolean
  hasPriceChanged?: boolean
  showFrom?: boolean
  isInformationAvailable?: boolean
}

export const PricePanelAmount = ({
  price,
  currency,
  taxDisplayName,
  showFrom,
  greyedOut,
  hasPriceChanged,
  isInformationAvailable = true,
}: IProps) => {
  return (
    <PricePanelAmountWrapper justifyStart greyedOut={greyedOut}>
      <PricePanelAmountStyled>
        <H5 inline color={Theme.grey900Color}>
          {showFrom && (
            <Fragment>
              <FormattedMessage id="core.text.from" />
              &nbsp;
            </Fragment>
          )}
          <Container inlineFlex alignItems="center" gap={0.125} noWrap>
            <Price
              quantity={price}
              currency={currency}
              rounded
              pattern={hasPriceChanged ? '!###,###*' : undefined}
            />
          </Container>
        </H5>

        {taxDisplayName && taxDisplayName !== 'N/A' && (
          <H5 inline light color={Theme.grey900Color}>
            &nbsp;
            <FormattedMessage
              id="submission.fullView.pricePanel.tax.text"
              values={{ taxName: taxDisplayName }}
            />
          </H5>
        )}
      </PricePanelAmountStyled>
      &nbsp;
      {isInformationAvailable && <Icon glyph="information" color={Theme.grey900Color} />}
    </PricePanelAmountWrapper>
  )
}

export default PricePanelAmount
